<div class="form-modal" *ngIf="form">
  <h1 mat-dialog-title>{{'CONFIRM_RECEPTION' | translate}}: {{documentNumber}}</h1>
  <div mat-dialog-content>
    <form [formGroup]="form" class="form-horizontal">
      <div class="form-group">
        <div class="col-lg-12 col-md-12 col-sm-12 no-padding">
          <div *ngIf="!hideReceptionNumber" class="col-md-3 col-sm-12">
            <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.ReceptionNumber || !form.controls.ReceptionNumber.valid}">
              <mat-label>{{ 'RECEPTION_NUMBER' | translate}}</mat-label>
              <input matInput formControlName="ReceptionNumber">
            </mat-form-field>
            <span *ngIf="formErrors.ReceptionNumber" class="field-validation-valid text-danger" [translate]
              [translateParams]="formErrorsParam.ReceptionNumber">{{ formErrors.ReceptionNumber }}</span>
          </div>
          <div class="col-md-3 col-sm-12">
            <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': formErrors.GuideNumber || !form.controls.GuideNumber.valid}">
              <mat-label>{{ 'GUIDE_NUMBER' | translate}}</mat-label>
              <input matInput formControlName="GuideNumber" class="one">

              <!-- Se existir o Setting, permite selecionar uma Guia associada à Encomenda -->
                <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectAssociatedDeliveryNote()" *ngIf="allowSelectDeliveryNoteOnReception"></i>
            </mat-form-field>
            <span *ngIf="formErrors.GuideNumber" class="field-validation-valid text-danger" [translate]
              [translateParams]="formErrorsParam.GuideNumber">{{ formErrors.GuideNumber }}</span>
          </div>
        </div>
        <div class="col-md-12 col-sm-12 spacer-bottom-xs"></div>
        <div class="table-responsive col-lg-12 col-md-12 col-sm-12 no-padding">
          <div *ngIf="form.controls.DetailsList.length>0">
            <div *ngIf="formErrorsDetails.length>0" class="validation-summary-errors text-danger col-md-6">
              <ul>
                <li *ngFor="let errorMessage of formErrorsDetails; let i = index" [translate] [translateParams]="formErrorsDetailsParam[i]">{{errorMessage}}</li>
              </ul>
            </div>
            <table class="reception-table table-bordered" id="reception-table" formArrayName="DetailsList"
              cdkFocusInitial>
              <thead>
                <tr>
                  
                  <th width="4%" class="text-center">
                    <strong>#</strong>
                  </th>
                  <th width="8%">
                    <strong>{{'CODE'|translate}}</strong>
                  </th>
                  <th width="20%">
                    <strong>{{'DESCRIPTION'|translate}}</strong>
                  </th>
                  <th width="10%" *ngIf="showUOMCodeOnReception">
                    <strong>{{'UNIT_DATATABLE_HEAD'|translate}}</strong>
                  </th>
                  <th width="10%" *ngIf="!hideOrderedQuantity">
                    <strong>{{'ORDERED_QUANTITY'|translate}}</strong>
                  </th>
                  <th width="7%">
                    <strong>{{'RECEIVED_QUANTITY_PREVIOUSLY'|translate}}</strong>
                  </th>
                  <th *ngIf="showRevisedQuantity" width="7%">
                    <strong>{{'QUANTITY_TO_RECEIVE'|translate}}</strong>
                  </th>
                  <th *ngIf="showDispatchedQuantity" width="7%">
                    <strong>{{'DISPATCHED_QUANTITY'|translate}}</strong>
                  </th>
                  
                  <th width="7%">
                    <strong>{{'RECEIVED_QUANTITY'|translate}}</strong>
                  </th>
                  <th *ngIf="showReturnedQuantity" width="7%">
                    <strong>{{'RETURNED_QUANTITY_PREVIOUSLY'|translate}}</strong>
                  </th>
                  <th *ngIf="showReturnedQuantity" width="7%">
                    <strong>{{'RETURNED_QUANTITY'|translate}}</strong>
                  </th>

                  <!-- Motivos de devolução -->
                  <th *ngIf="showReturnedQuantity && showReturnReasons" width="11%">
                    <strong>{{'REASON_FOR_RETURN'|translate}}</strong>
                  </th>

                  <!-- Avaliações p/ Otis -->
                  <th *ngIf="isReceptionHasExtendedEvals" width="10%">
                    <strong>{{'DATE_EVALUATION'|translate}}</strong>
                  </th>
                  <th *ngIf="isReceptionHasExtendedEvals" width="10%">
                    <strong>{{'QTD_EVALUATION'|translate}}</strong>
                  </th>
                  <th *ngIf="isReceptionHasExtendedEvals" width="10%">
                    <strong>{{'PROD_EVALUATION'|translate}}</strong>
                  </th>
                  <!-- Avaliação por defeito -->
                  <th *ngIf="!isReceptionHasExtendedEvals" width="10%">
                    <strong>{{'EVALUATION'|translate}}</strong>
                  </th>
                  <th *ngIf="associateInvoiceToReception" width="15%">
                    <strong>{{'INVOICE'|translate}}</strong>
                  </th>
                  <th width="4%" class="text-center">
                    <strong>{{'OBS_ABBREVIATION'|translate}}</strong>
                  </th>
                  <th width="4%" class="text-center" *ngIf="showCloseLine">
                    <strong>{{'CLOSE' | translate}}</strong>
                    <br>
                    <mat-checkbox [(ngModel)]="closeAll" [ngModelOptions]="{standalone: true}" (click)="checkboxesAction()">
                    </mat-checkbox>
                  </th>
                </tr>
              </thead>
              <tbody *ngFor="let item of form.controls.DetailsList.controls; let i=index" [formGroupName]="i">
                <tr>
                  
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="LineNumber" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="Code" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="Description" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td *ngIf="showUOMCodeOnReception">
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="OrderedQuantityUOMCode" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td *ngIf="!hideOrderedQuantity">
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="OrderedQuantity" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  
                  <td>
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="ReceivedQuantityPreviously" class="no-padding-left">
                    </mat-form-field>
                  </td>

                  <td *ngIf="showRevisedQuantity">
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="QuantityToReceive" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td *ngIf="showDispatchedQuantity">
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="DespatchedQuantity" class="no-padding-left">
                    </mat-form-field>
                  </td>

                  <td>
                    <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': !form.controls.DetailsList.controls[i].controls.ReceivedQuantity.valid }">
                      <input matInput formControlName="ReceivedQuantity" (input)="receivedQuantityChange($event.target.value, i)"
                        class="no-padding-left" type="number">
                    </mat-form-field>
                  </td>

                  <td *ngIf="showReturnedQuantity">
                    <mat-form-field class="allwidth">
                      <input matInput formControlName="ReturnedQuantityPreviously" class="no-padding-left">
                    </mat-form-field>
                  </td>
                  <td *ngIf="showReturnedQuantity">
                    <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': !form.controls.DetailsList.controls[i].controls.ReturnedQuantity.valid }">
                      <input matInput formControlName="ReturnedQuantity" (input)="returnedQuantityChange($event.target.value, i)"
                        class="no-padding-left" type="number">
                    </mat-form-field>
                  </td>
                  <td *ngIf="showReturnedQuantity && showReturnReasons">
                    <mat-form-field class="allwidth">
                      <mat-select formControlName="ReturnReasonID" (selectionChange)="onSelectReturnReasonID($event.value, i)"
                        [ngClass]="{ 'mat-input-invalid': !form.controls.DetailsList.controls[i].controls.ReturnReasonID.valid}">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of returnReasonsList" [value]="item.ID">{{item.ItemName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="isReceptionHasExtendedEvals">
                    <mat-form-field class="allwidth">
                      <mat-select formControlName="EvalDateID" (selectionChange)="onSelectEvalDateID($event.value, i)"
                        [ngClass]="{ 'mat-input-invalid': !form.controls.DetailsList.controls[i].controls.EvalDateID.valid}">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of deliveryDateEvalList" [value]="item.ItemCode">{{item.ItemName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="isReceptionHasExtendedEvals">
                    <mat-form-field class="allwidth">
                      <mat-select formControlName="EvalQtdID" (selectionChange)="onSelectEvalQtdID($event.value, i)"
                        [ngClass]="{ 'mat-input-invalid': !form.controls.DetailsList.controls[i].controls.EvalQtdID.valid}">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of receivedQuantityEvalList" [value]="item.ItemCode">{{item.ItemName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="isReceptionHasExtendedEvals">
                    <mat-form-field class="allwidth">
                      <mat-select formControlName="EvalProdID" (selectionChange)="onSelectEvalProdID($event.value, i)"
                        [ngClass]="{ 'mat-input-invalid': !form.controls.DetailsList.controls[i].controls.EvalProdID.valid}">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of productEvalList" [value]="item.ItemCode">{{item.ItemName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="!isReceptionHasExtendedEvals">
                    <mat-form-field class="allwidth">
                      <mat-select formControlName="Evaluation" (selectionChange)="onSelectEvaluation($event.value, i)"
                        [ngClass]="{ 'mat-input-invalid': !form.controls.DetailsList.controls[i].controls.Evaluation.valid}">
                        <mat-option></mat-option>
                        <mat-option *ngFor="let item of evaluationEvalList" [value]="item.ItemCode">{{item.ItemName}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>
                  <td *ngIf="associateInvoiceToReception">
                    <mat-form-field class="allwidth" [ngClass]="{ 'mat-input-invalid': !form.controls.DetailsList.controls[i].controls.InvoiceNumber.valid }">
                      <input matInput formControlName="InvoiceNumber" class="one">
                      <!-- Se existir o Setting, permite selecionar uma Guia associada à Encomenda -->
                        <i matSuffix class="glyphicon glyphicon-new-window" (click)="selectAssociateInvoice(i)"></i>
                    </mat-form-field>
                  </td>
                  <td class="text-center">
                    <button type="button" class="btn btn-sm" (click)="addRowObservations(i, open); open = !open">
                      <span>
                        <i id="obs-icon-{{i}}" class="fas fa-plus blue backwhite"></i>
                      </span>
                    </button>
                  </td>
                  <td class="text-center" *ngIf="showCloseLine">
                    <mat-checkbox type="checkbox" class="closeCheck"  formControlName="Close" (click)="onChangeClose(form.controls.DetailsList.controls[i].controls.ID.value)">
                    </mat-checkbox>
                  </td>
                </tr>
                <tr class="hide" id="obs-{{i}}">
                  <td colspan="30">
                    <mat-form-field class="allwidth">
                      <textarea matInput formControlName="Observations" class="no-resize" rows="3"></textarea>
                    </mat-form-field>
                  </td>
                </tr>
                
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div mat-dialog-actions>
    <div class="full-width text-right">
      <button type="button" class="btn btn-default" (click)="resetForm();dialogRef.close(null)">
        <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
      </button>
      <button type="button" class="btn btn-primary" (click)="save()">
        <i class="far fa-save"></i>&nbsp;{{'BUTTON.SAVE' | translate}}
      </button>
    </div>
  </div>
</div>